module.exports = __webpack_public_path__ + "img/fullmoon.59f7a97d.png";